import { ChangePasswordForm } from './ChangePasswordForm';
import { LoginFrame } from './LoginFrame';

export type ChangePasswordWidgetProps = {
  onBackToLogin: () => void;
  onSubmit: (newPassword: string) => void;
  backLabel: string;
  title: string;
  passwordError?: string;
  generalError?: string;
};

export function ChangePasswordWidget({
  onBackToLogin,
  onSubmit,
  backLabel,
  title,
  passwordError,
  generalError,
}: ChangePasswordWidgetProps) {
  return (
    <LoginFrame title={title}>
      <ChangePasswordForm
        onSubmit={onSubmit}
        onBackToLogin={onBackToLogin}
        backLabel={backLabel}
        passwordError={passwordError}
        generalError={generalError}
      />
    </LoginFrame>
  );
}
